import {MANAGEMENT, REPORT_AND_ANALYSIS} from "../../shared/helpers/modules";
import {ADMIN_ROLE, CUSTOMER_ROLE, OPERATOR_ROLE} from "../../shared/helpers/user";

export const canAccessModule = function (user, moduleName) {
  return !(
    (moduleName === REPORT_AND_ANALYSIS && user?.role === OPERATOR_ROLE) ||
    (moduleName === MANAGEMENT && ![ADMIN_ROLE, OPERATOR_ROLE, CUSTOMER_ROLE].includes(user.role))
  );
}